import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b7faff16"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "topwrapper" }
const _hoisted_2 = { class: "topinfo" }
const _hoisted_3 = {
  key: 0,
  class: "delay-tag"
}
const _hoisted_4 = {
  key: 0,
  class: "RiseandFallarrow"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 1,
  class: "RiseandFallarrow"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "clearfix" }
const _hoisted_11 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_UpOutlined = _resolveComponent("UpOutlined")!
  const _component_DownOutlined = _resolveComponent("DownOutlined")!
  const _component_a_anchor_link = _resolveComponent("a-anchor-link")!
  const _component_a_anchor = _resolveComponent("a-anchor")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_typography_title, { level: 3 }, {
        default: _withCtx(() => [
          _createElementVNode("i", null, _toDisplayString(_ctx.currentshares.InstrumentID) + " " + _toDisplayString(_ctx.currentshares.name), 1),
          (_ctx.isDelayHK)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "延"))
            : _createCommentVNode("", true),
          _createElementVNode("span", {
            class: _normalizeClass([_ctx.currentshares.RiseandFall > 0 ? 'red' : _ctx.currentshares.RiseandFall < 0 ? 'green' : ''])
          }, [
            _createElementVNode("strong", {
              class: _normalizeClass({ 'namalstyle': _ctx.getFormattedPrice(_ctx.currentshares.LastPrice) === '—' })
            }, _toDisplayString(_ctx.getFormattedPrice(_ctx.currentshares.LastPrice)), 3),
            (_ctx.theme === 'dark')
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                  (_ctx.currentshares.RiseandFall > 0)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: require('@/assets/top_light.png'),
                        alt: ""
                      }, null, 8, _hoisted_5))
                    : (_ctx.currentshares.RiseandFall < 0)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          src: require('@/assets/bottom_dark.png'),
                          alt: ""
                        }, null, 8, _hoisted_6))
                      : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_7, [
                  (_ctx.currentshares.RiseandFall > 0)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: require('@/assets/top_light.png'),
                        alt: ""
                      }, null, 8, _hoisted_8))
                    : (_ctx.currentshares.RiseandFall < 0)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          src: require('@/assets/bottom_light.png'),
                          alt: ""
                        }, null, 8, _hoisted_9))
                      : _createCommentVNode("", true)
                ]))
          ], 2)
        ]),
        _: 1
      }),
      _createElementVNode("span", {
        class: _normalizeClass([_ctx.currentshares.RiseandFall > 0 ? 'red' : _ctx.currentshares.RiseandFall < 0 ? 'green' : ''])
      }, _toDisplayString(_ctx.getFormattedChange(_ctx.currentshares.RiseandFall)), 3),
      _createElementVNode("span", {
        class: _normalizeClass([_ctx.currentshares.increase > 0 ? 'red' : _ctx.currentshares.increase < 0 ? 'green' : ''])
      }, _toDisplayString(_ctx.getFormattedChangePercent(_ctx.currentshares.increase)), 3),
      _createElementVNode("span", {
        class: "isopen",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isOpen = !_ctx.isOpen))
      }, [
        _createTextVNode(_toDisplayString(_ctx.isOpen ? '收起' : '展开') + " ", 1),
        (_ctx.isOpen)
          ? (_openBlock(), _createBlock(_component_UpOutlined, { key: 0 }))
          : (_openBlock(), _createBlock(_component_DownOutlined, { key: 1 }))
      ])
    ]),
    _createElementVNode("div", {
      class: "ishidden",
      style: _normalizeStyle({ height: _ctx.isOpen ? '170px' : '12px' })
    }, [
      _createElementVNode("ul", _hoisted_10, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lis, (item) => {
          return (_openBlock(), _createElementBlock("li", {
            key: item.key,
            class: _normalizeClass(_ctx.currentli === item.key ? 'active' : ''),
            style: { width: 100 / 6 + '%' }
          }, [
            _createElementVNode("div", {
              onClick: ($event: any) => (_ctx.changenav(item))
            }, _toDisplayString(item.name), 9, _hoisted_11)
          ], 2))
        }), 128))
      ]),
      (_openBlock(), _createBlock(_component_a_anchor, {
        key: _ctx.key,
        affix: false,
        "get-container": _ctx.target,
        "target-offset": 220,
        onChange: _ctx.changehash
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nav, (item, i) => {
            return (_openBlock(), _createBlock(_component_a_anchor_link, {
              key: 'nav' + i,
              href: '#' + item.key,
              title: item.title,
              onClick: _ctx.selecthash
            }, null, 8, ["href", "title", "onClick"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["get-container", "onChange"]))
    ], 4)
  ]))
}